module.exports = __webpack_public_path__ + "img/crab.be5030ca.webp";